import {ContainerForm, DivForm, DivFormInfo} from "./styles";

import React from "react";

export interface IPropsFormCreate{
  title: string;
  icon?: any;
  children: any;
}

export default function FormCreate(props : IPropsFormCreate){
  return(
    <ContainerForm>
      <DivFormInfo>{props.title} {props.icon}</DivFormInfo>
      <DivForm>
        {props.children}
      </DivForm>
    </ContainerForm>
  );
}
